{
  "index.description": "Откройте игру на телефоне или проекторе в той же Wi‑Fi сети, которую использует телевизор, и используйте его как контроллер.",
  "index.go_to_tv": "Перейти к TV",

  "tv.players": "Игроки",
  "tv.waiting": "Ожидание…",
  "tv.scan_qr": "Сканируйте QR код",
  "tv.point_camera": "Наведите камеру телефона на этот QR",
  "tv.enter_code": "Или введите код ниже вручную в приложении:",
  "tv.same_wifi": "Если подключение слабое, убедитесь, что телефон и телевизор находятся в одной Wi-Fi сети",
  "tv.need_help": "Мне нужна помощь",
  "tv.post_qr_hint": "Если игра долго не запускается на мобильном устройстве, нажмите «Отсоединить» или обновите страницу, затем подключитесь заново.\n\nДля стабильной работы используйте одну и ту же Wi-Fi сеть как на телевизоре, так и на телефоне.",
  "tv.refresh_page": "Обновить страницу",
  "tv.choose_game": "Выберите игру на телефоне",
  "tv.refresh_qr": "Обновить",
  "tv.connecting": "Идёт подключение…",
  "tv.available_games": "Доступные игры для браузера:",
  "tv.establishing": "Устанавливаем соединение\nс вашим телефоном",
  "tv.send_logs": "Отправить лог",
  "tv.sending_logs": "Отправляем логи…",
  "tv.net.direct": "Отличное соединение",
  "tv.net.different": "Похоже, телефон и телевизор в разных сетях. Подключите их к одному Wi-Fi",
  "tv.net.internet": "Соединение через интернет — возможны задержки. Лучше подключиться к одному Wi-Fi",
  "tv.net.relay": "Медленное соединение. Подключите телефон и телевизор к одному Wi-Fi",
  "tv.net.same_network_blocked": "Вы в одной Wi-Fi сети, но прямое подключение недоступно — возможны задержки. Проверьте, что телефон не в гостевой сети",
  "tv.net.different_lan": "Телефон и телевизор подключены к разным роутерам — прямое подключение недоступно, возможны задержки. Подключите их к одному Wi-Fi",
  "tv.net.failed": "Не удалось подключиться. Проверьте, что оба устройства в одной Wi-Fi сети, и попробуйте снова",
  "tv.net.unstable": "Нестабильное подключение",
  "tv.net.got_it": "Понятно",
  "tv.connection_lost": "Соединение прервано",
  "tv.connection_lost_sub": "Телефон потерял связь с телевизором.\nУбедитесь, что оба устройства в одной Wi-Fi сети",
  "tv.reconnect": "Подключиться снова",
  "tv.game_unavailable": "Игра недоступна",
  "tv.game_unavailable_sub": "Чтобы играть через телевизор, выбери игру с такой иконкой",
  "tv.p2p_rtt_title": "P2P: задержка ICE (RTT), по статистике WebRTC",
  "tv.webrtc_stats_title": "FPS (отрисовка), сообщений DataChannel/с (сырой поток), ICE RTT (мс)",

  "game.game_over": "ИГРА ОКОНЧЕНА",
  "game.score": "Счёт:",
  "game.winner": "ПОБЕДИТЕЛЬ!",
  "game.tie": "НИЧЬЯ!",
  "game.pause": "ПАУЗА",
  "fruit.combo": "Комбо x {n}",
  "fruit.score": "СЧЁТ",
  "game.classic": "Классика",
  "game.arcade": "Аркада",
  "game.zen": "Дзен",
  "game.level": "Уровень",
  "game.points": "Очки",

  "calib.dark.title": "Темновато! Мы тебя не видим!",
  "calib.dark.sub": "Включи свет или встань к окну",
  "calib.bright.title": "Слишком светло! Мы тебя не видим!",
  "calib.bright.sub": "Прикрой штору или отойди от окна",
  "calib.low_conf.title": "Никак не можем тебя разглядеть!",
  "calib.low_conf.sub": "Возможно что-то загораживает или ты сливаешься с фоном",

  "tv.log_sent": "Лог отправлен (записей: {n})",
  "tv.log_send_error": "Ошибка отправки лога",
  "tv.entered_code": "Введённый код:",
  "tv.connected": "Подключено!",
  "tv.choose_game_title": "Выбери игру на телефоне",
  "tv.choose_game_sub": "Откройте приложение на телефоне и выберите игру, в которую хотите сыграть",
  "tv.choose_mode_title": "Выбери режим игры\nи количество игроков",
  "tv.choose_mode_sub": "Выберите один из доступных режимов и количество игроков",
  "tv.game": "Игра",
  "tv.press_start": "Нажмите СТАРТ на телефоне.",
  "tv.mode_summary": "Режим: {mode} · {players}.",
  "tv.players_one": "{n} игрок",
  "tv.players_many": "{n} игрока",
  "tv.pose_to_start": "Встаньте в позу — игра начнётся автоматически.",
  "tv.p2p_connecting": "Подключение P2P…",
  "tv.p2p_connecting_sub": "Ожидается прямой канал с телефоном (WebRTC DataChannel). На одной Wi‑Fi обычно достаточно STUN; иначе настройте TURN.",
  "tv.p2p_failed": "P2P не удался",
  "tv.p2p_failed_sub": "Проверьте сеть и браузер на ТВ. Вне локальной сети часто нужен TURN — см. docs/webrtc-native-connection.md",
  "tv.p2p_timeout": "P2P не установлен",
  "tv.p2p_timeout_sub": "Истекло время ожидания. Нужны WebRTC и UDP; на части ТВ/сетей без TURN соединение невозможно.",
  "tv.p2p_reconnecting": "P2P: повторное подключение…",
  "tv.p2p_no_link": "P2P: нет связи",
  "tv.browser_outdated": "Ваш браузер устарел",
  "tv.browser_unsupported": "Браузер, который в данный момент используется, к сожалению,\nне поддерживается.\nПожалуйста, используйте один из поддерживаемых браузеров",

  "game.flight_over": "Полёт окончен! ⭐ {stars}",
  "game.chef_time_up": "Время вышло! Счёт: {score}",
  "game.chef_load_failed": "Не удалось загрузить игру",
  "game.sky_race_over": "Забег окончен! ⭐ {stars} · {meters}",
  "game.iq_over": "Раунд окончен! Очки: {score} · Верно: {correct} из {total}",
  "game.building_world": "{map} — строим мир… {pct}%",
  "game.meters": "{n} м",
  "game.laser_dodge_warning": "Уйди из красной зоны!",
  "game.laser_dodge_round": "Раунд {n}",
  "game.laser_dodge_dodged": "Увернулся! +{n}",
  "game.laser_dodge_hit": "Попался!",
  "game.laser_dodge_not_seen": "Тебя не видно",
  "game.laser_dodge_over": "Игра окончена! Счёт {score} · Раунд {round}",
  "game.choose_track": "Выбери трассу",

  "map.ekibastuz": "Экибастуз",
  "map.astana": "Астана",
  "map.paris": "Париж",
  "map.barcelona": "Барселона",
  "map.almaty": "Алматы",

  "calib.hint.upper_body": "Встаньте внутри указанной зоны так, чтобы были видны плечи и руки",
  "calib.hint.waist_up": "Встаньте внутри зоны так чтобы было видно тело от пояса до головы",
  "calib.hint.full_body": "Встаньте внутри указанной зоны так чтобы было видно всё тело",
  "calib.hint.slice_to_start": "Срежьте фрукт, чтобы начать игру",
  "calib.hint.touch_yellow_zone": "Коснитесь внутри жёлтой зоны, чтобы начать",
  "calib.hint.touch_zone": "Коснитесь внутри зоны, чтобы начать",
  "calib.start": "Старт",

  "headless.menu_title": "Выберите игру",
  "headless.menu_sub": "Наведите руку на кнопку и задержите — или нажмите OK на пульте",
  "headless.mode_title": "Режим",
  "headless.mode_timed": "На время",
  "headless.mode_standard": "Без таймера",
  "headless.level_title": "Уровень",
  "headless.play_again": "Ещё раз",
  "headless.to_menu": "В меню",
  "headless.result_title": "Забег окончен!",
  "headless.result": "⭐ {stars} · {meters}",
  "headless.lost_body": "Встаньте в кадр, чтобы продолжить",
  "headless.level_default": "Долина"
}
